import { render, staticRenderFns } from "./Pendant.vue?vue&type=template&id=05b89e54&scoped=true"
import script from "./Pendant.vue?vue&type=script&lang=js"
export * from "./Pendant.vue?vue&type=script&lang=js"
import style0 from "./Pendant.vue?vue&type=style&index=0&id=05b89e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b89e54",
  null
  
)

export default component.exports